<template>
  <template v-if="hasValidUrl">
    <template v-if="buttonStyle === 'primary'">
      <MBZCTAButton
        :label="buttonLabel"
        :url="buttonUrl"
        :icon-position="iconPosition"
        :icon="resolvedIcon"
        :disabled="disabled"
        severity="primary"
      />
    </template>

    <template v-else-if="buttonStyle === 'secondary'">
      <MBZCTAButton
        :label="buttonLabel"
        :url="buttonUrl"
        :icon-position="iconPosition"
        :icon="resolvedIcon"
        :disabled="disabled"
        severity="secondary"
      />
    </template>

    <template v-else-if="buttonStyle === 'tertiary'">
      <MBZCTAButton
        :label="buttonLabel"
        :url="buttonUrl"
        :icon-position="iconPosition"
        :icon="resolvedIcon"
        :disabled="disabled"
        severity="tertiary"
      />
    </template>

    <template v-else>
      <MBZCTADefault
        :label="buttonLabel"
        :url="buttonUrl"
        :icon-position="iconPosition"
        :icon="resolvedIcon"
        :disabled="disabled"
        :size="size"
      />
    </template>
  </template>
</template>

<script setup lang="ts">
import type { CallToAction } from '~/types';

const props = withDefaults(defineProps<CallToAction>(), {
  buttonLabel: 'Learn More',
  buttonStyle: 'default',
  buttonUrl: undefined,
  iconPosition: 'right',
  icon: 'arrow',
  disabled: false,
  size: undefined,
});

const hasValidUrl = computed(() => {
  const href = props.buttonUrl?.href;
  return !!href && href.trim() !== '' && href !== '#';
});

const resolvedIcon = computed(() => props.icon);
</script>
